import React from 'react';
import { Crown, Trophy, Gift, Ticket, Check, Headset, Percent } from 'lucide-react';
import { SOCIALS } from '../mock';
import { useReveal } from '../hooks/useReveal';

const APPLY = [
  'Wagering $100K–$250K per month',
  'Able to verify your existing casino account',
  'Open a VIP ticket in Discord to start',
];

const PERKS = [
  { Icon: Headset, text: 'Your own dedicated VIP host' },
  { Icon: Percent, text: 'Up to 10% rolling lossback' },
  { Icon: Trophy, text: 'Cash rewards for slot wager targets' },
  { Icon: Gift, text: 'Access to extra rewards and promotions' },
];

export default function VIP() {
  useReveal();
  return (
    <section id="vip" className="py-16 sm:py-24 relative">
      <div className="ar-container">
        <div className="text-center mb-10 sm:mb-14 reveal">
          <p className="ar-eyebrow !text-gold mb-3 flex items-center justify-center gap-2">
            <Crown size={16} aria-hidden="true" /> VIP Program
          </p>
          <h2 className="ar-heading text-3xl sm:text-4xl md:text-5xl mb-4">Roobet VIP <span className="text-cyan">Transfers</span></h2>
          <p className="text-muted max-w-2xl mx-auto">
            Already a VIP at another casino? Apply to bring your status to Roobet. Each application is reviewed individually and benefits apply only after approval.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {/* Who can apply */}
          <div className="ar-panel ar-panel-hover p-7 reveal reveal-scale" style={{ animationDelay: '0s' }}>
            <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5" style={{ background: 'rgba(0,217,255,0.1)', border: '1px solid rgba(0,217,255,0.3)' }}>
              <Trophy size={26} className="text-cyan" style={{ filter: 'drop-shadow(0 0 8px rgba(0,217,255,0.6))' }} />
            </div>
            <h3 className="font-display font-bold text-lg mb-5 tracking-wide">WHO CAN APPLY</h3>
            <ul className="space-y-3">
              {APPLY.map((a) => (
                <li key={a} className="flex items-start gap-3 text-sm text-muted">
                  <Check size={16} className="text-cyan mt-0.5 flex-shrink-0" />
                  {a}
                </li>
              ))}
            </ul>
          </div>

          {/* What you get */}
          <div className="ar-panel ar-panel-hover p-7 reveal reveal-scale" style={{ borderColor: 'rgba(0,217,255,0.3)', animationDelay: '0.12s' }}>
            <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5" style={{ background: 'rgba(0,217,255,0.1)', border: '1px solid rgba(0,217,255,0.35)' }}>
              <Crown size={26} className="text-gold" style={{ filter: 'drop-shadow(0 0 8px rgba(0,217,255,0.6))' }} />
            </div>
            <h3 className="font-display font-bold text-lg mb-2 tracking-wide">POSSIBLE BENEFITS</h3>
            <p className="text-xs text-muted mb-4">After an approved transfer. Exact terms are confirmed in your ticket.</p>
            <ul className="space-y-3">
              {PERKS.map((p) => (
                <li key={p.text} className="flex items-start gap-3 text-sm text-muted">
                  <p.Icon size={16} className="text-gold mt-0.5 flex-shrink-0" />
                  {p.text}
                </li>
              ))}
            </ul>
          </div>

          {/* First deposit perk */}
          <div className="ar-panel ar-panel-hover p-7 reveal reveal-scale flex flex-col" style={{ animationDelay: '0.24s' }}>
            <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5" style={{ background: 'rgba(0,217,255,0.1)', border: '1px solid rgba(0,217,255,0.3)' }}>
              <Gift size={26} className="text-cyan" style={{ filter: 'drop-shadow(0 0 8px rgba(0,217,255,0.6))' }} />
            </div>
            <h3 className="font-display font-bold text-lg mb-5 tracking-wide">FIRST DEPOSIT PERK</h3>
            <div className="font-display font-bold text-4xl text-gold mb-3">UP TO 10%</div>
            <p className="text-sm text-muted leading-relaxed">
              On your first deposit after an approved transfer, in place of a standard welcome bonus. Subject to approval and the terms confirmed in your ticket.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="ar-panel p-7 sm:p-9 text-center reveal" style={{ borderColor: 'rgba(0,217,255,0.3)' }}>
          <h3 className="font-display font-bold text-xl sm:text-2xl mb-3">Ready To Transfer?</h3>
          <p className="text-muted max-w-xl mx-auto mb-7">
            Open a VIP Transfer Ticket in our Discord to start the review. You'll get the requirements and exact terms before anything is approved.
          </p>
          <a href={SOCIALS.discord} target="_blank" rel="noopener noreferrer" className="btn-gold" data-testid="vip-open-ticket-btn">
            <Ticket size={18} /> OPEN A VIP TICKET
          </a>
        </div>
      </div>
    </section>
  );
}
